<template>
  <div
    class="ba-absolute ba-top-full ba-z-10 ba-w-1/2 ba-h-16 ba--mt-4 ba-pl-12"
    :class="color"
  >
    <div class="ba-absolute ba-right-0 ba-top-0 ba-h-8 ba-w-1/2 ba-mt-px ba-border-r ba-border-b ba-border-current ba-rounded-br-2xl" />
    <div class="ba-absolute ba-left-12 ba-bottom-0 ba-h-8 ba-w-1/2 ba-border-l ba-border-t ba-border-current ba-rounded-tl-2xl" />
  </div>
</template>

<script>
export default {
  name: "vis-approval-queue-stage-connection-line",
  props: {
    color: {
      type: String,
      default: null
    }
  }
}
</script>
